export const themes = {
  move: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  abreumob: {
    primary: '#12acff',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  contaverde: {
    primary: '#436f32',
    selectedDiv: 'rgba(0, 171, 87, 0.1)',
    hoveredDiv: 'rgba(0, 171, 87, 0.1)',
    selectedIcon: '#436f32',
  },
  fastpower: {
    primary: '#436f32',
    selectedDiv: 'rgba(0, 171, 87, 0.1)',
    hoveredDiv: 'rgba(0, 171, 87, 0.1)',
    selectedIcon: '#436f32',
  },
  celesc: {
    primary: '#2288C8',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#2288C8',
  },
  terpel: {
    primary: '#C4141E',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  'test-terpel': {
    primary: '#C4141E',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  copel: {
    primary: '#ec642c',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#ec642c',
  },
  eletricus: {
    primary: '#0341b6',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  emb: {
    primary: '#0341b6',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  bmjrecargas: {
    primary: '#368bd6',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#368bd6',
  },
  inpulse: {
    primary: '#0341b6',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  nansen: {
    primary: '#0341b6',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  rinno: {
    primary: '#0341b6',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  starbrasil: {
    primary: '#ef8903',
    selectedDiv: 'rgba(241, 148, 61, 0.1)',
    hoveredDiv: 'rgba(250, 163, 50, 0.1)',
    selectedIcon: '#ef8903',
  },
  solar: {
    primary: '#00ab57',
    selectedDiv: 'rgba(0, 171, 87, 0.1)',
    hoveredDiv: 'rgba(0, 171, 87, 0.1)',
    selectedIcon: '#00ab57',
  },
  intelbras: {
    primary: '#00a335',
    selectedDiv: 'rgba(135, 201, 132, 0.5)',
    hoveredDiv: 'rgba(135, 201, 132, 0.5)',
    selectedIcon: '#007a39',
  },
  'test-intelbras': {
    primary: '#00a335',
    selectedDiv: 'rgba(135, 201, 132, 0.5)',
    hoveredDiv: 'rgba(135, 201, 132, 0.5)',
    selectedIcon: '#007a39',
  },
  terpel_equador: {
    primary: '#C4141E',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  vertys: {
    primary: '#d47c00',
    selectedDiv: 'rgba(212, 124, 0, 0.1)',
    hoveredDiv: 'rgba(212, 124, 0, 0.1)',
    selectedIcon: '#d47c00',
  },
  equatorial: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  tabanet: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  oncharge: {
    primary: '#000000',
    selectedDiv: 'rgba(109, 109, 109, 0.1)',
    hoveredDiv: 'rgba(148, 148, 148, 0.1)',
    selectedIcon: '#000000',
  },
  zerozero7: {
    primary: '#000000',
    selectedDiv: 'rgba(109, 109, 109, 0.1)',
    hoveredDiv: 'rgba(148, 148, 148, 0.1)',
    selectedIcon: '#000000',
  },
  ita: {
    primary: '#000000',
    selectedDiv: 'rgba(109, 109, 109, 0.1)',
    hoveredDiv: 'rgba(148, 148, 148, 0.1)',
    selectedIcon: '#000000',
  },
  ims: {
    primary: '#76b900',
    selectedDiv: 'rgba(107, 250, 50, 0.1)',
    hoveredDiv: 'rgba(107, 250, 50, 0.1)',
    selectedIcon: '#76b900',
  },
  new_mobility: {
    primary: '#17ab81',
    selectedDiv: 'rgba(107, 250, 50, 0.1)',
    hoveredDiv: 'rgba(107, 250, 50, 0.1)',
    selectedIcon: '#17ab81',
  },
  carregar: {
    primary: '#5cad2f',
    selectedDiv: 'rgba(107, 250, 50, 0.1)',
    hoveredDiv: 'rgba(107, 250, 50, 0.1)',
    selectedIcon: '#5cad2f',
  },
  boxcharge: {
    primary: '#84bf46',
    selectedDiv: '#84bf46',
    hoveredDiv: '#fccc25',
    selectedIcon: '#1f1f1f',
  },
  eletrocentro: {
    primary: '#fccc25',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#1f1f1f',
  },
  effort: {
    primary: '#ffb600;',
    selectedDiv: 'rgba(255, 196, 0, 0.699)',
    hoveredDiv: 'rgba(255, 196, 0, 0.699)',
    selectedIcon: '#ffb600',
  },
  dcc_energy: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  safira: {
    primary: '#0a0050',
    selectedDiv: 'rgba(10, 0, 80, 0.1)',
    hoveredDiv: 'rgba(10, 0, 80, 0.1)',
    selectedIcon: '#0a0050',
  },
  energia_atual: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  esolen: {
    primary: '#2FCB30',
    selectedDiv: 'rgba(107, 250, 50, 0.1)',
    hoveredDiv: 'rgba(107, 250, 50, 0.1)',
    selectedIcon: '#2FCB30',
  },
  pacto_mobility: {
    primary: '#29A2AE',
    selectedDiv: 'rgb(41,162,174, 0.1)',
    hoveredDiv: 'rgb(41,162,174, 0.1)',
    selectedIcon: '#29A2AE',
  },
  atm: {
    primary: '#2c2c2c',
    selectedDiv: '#2c2c2c',
    hoveredDiv: '#2c2c2c',
    selectedIcon: '#d8d8d8',
  },
  save: {
    primary: '#57b6b2',
    selectedDiv: 'rgba(87, 182, 178, 0.1)',
    hoveredDiv: 'rgba(148, 148, 148, 0.1)',
    selectedIcon: '#57b6b2',
  },
  demo: {
    primary: '#5cad2f',
    selectedDiv: 'rgba(107, 250, 50, 0.1)',
    hoveredDiv: 'rgba(107, 250, 50, 0.1)',
    selectedIcon: '#5cad2f',
  },
  energize_c: {
    primary: '#23ae4b',
    selectedDiv: 'rgba(35, 174, 75, 0.1)',
    hoveredDiv: 'rgba(35, 174, 75, 0.1)',
    selectedIcon: '#23ae4b',
  },
  kraper: {
    primary: '#d0661c',
    selectedDiv: 'rgba(208, 102, 28, 0.1)',
    hoveredDiv: 'rgba(208, 102, 28, 0.1)',
    selectedIcon: '#d0661c',
  },
  kinsol: {
    primary: '#993887',
    selectedDiv: 'rgba(153, 56, 135, 0.1)',
    hoveredDiv: 'rgba(153, 56, 135, 0.1)',
    selectedIcon: '#993887',
  },
  bidoo: {
    primary: '#0073FF',
    selectedDiv: 'rgba(0, 115, 255, 0.1)',
    hoveredDiv: 'rgba(0, 115, 255, 0.1)',
    selectedIcon: '#0073FF',
  },
  phb: {
    primary: '#0073FF',
    selectedDiv: 'rgba(0, 115, 255, 0.1)',
    hoveredDiv: 'rgba(0, 115, 255, 0.1)',
    selectedIcon: '#0073FF',
  },
  br_super_carga: {
    primary: '#6FB51F',
    selectedDiv: 'rgba(111, 181, 31, 0.1)',
    hoveredDiv: 'rgba(111, 181, 31, 0.1)',
    selectedIcon: '#6FB51F',
  },
  high_tech_energy: {
    primary: '#558c4a',
    selectedDiv: 'rgba(161,255,142,0.1)',
    hoveredDiv: 'rgba(161,255,142,0.1)',
    selectedIcon: '#558c4a',
  },
  linkplusenergy: {
    primary: '#285A84',
    selectedDiv: 'rgba(40, 90, 132, 0.1)',
    hoveredDiv: 'rgba(40, 90, 132, 0.1)',
    selectedIcon: '#5EA669',
  },
  evmove: {
    primary: '#015989',
    selectedDiv: '#d2f503',
    hoveredDiv: '#d2f503',
    selectedIcon: '#0341b6',
  },
  minascharger: {
    primary: '#94d60e',
    selectedDiv: 'rgba(148, 214, 14, 0.1)',
    hoveredDiv: 'rgba(148, 214, 14, 0.1)',
    selectedIcon: '#002469',
  },
  vespenergia: {
    primary: '#F9BF0F',
    selectedDiv: 'rgba(249, 191, 15, 0.1)',
    hoveredDiv: 'rgba(249, 191, 15, 0.1)',
    selectedIcon: '#241C4E',
  },
  joyenergy: {
    primary: '#F68E1E',
    selectedDiv: 'rgba(246, 142, 30, 0.1)',
    hoveredDiv: 'rgba(246, 142, 30, 0.1)',
    selectedIcon: '#020368',
  },
  kuara_energy: {
    primary: '#1d274a',
    selectedDiv: 'rgba(29, 39, 74, 0.1)',
    hoveredDiv: 'rgba(29, 39, 74, 0.1)',
    selectedIcon: '#93be23',
  },
  recargaev: {
    primary: '##27B7E1',
    selectedDiv: 'rgba(39, 182, 225, 0.1)',
    hoveredDiv: 'rgba(39, 182, 225, 0.1)',
    selectedIcon: '#606062',
  },
  prismaemobility: {
    primary: '#53d716',
    selectedDiv: 'rgba(83, 215, 22, 0.1)',
    hoveredDiv: 'rgba(83, 215, 22, 0.1)',
    selectedIcon: '#000000',
  },
  intelbras_uruguai: {
    primary: '#00a335',
    selectedDiv: 'rgba(135, 201, 132, 0.5)',
    hoveredDiv: 'rgba(135, 201, 132, 0.5)',
    selectedIcon: '#007a39',
  },
  evoluoultracharge: {
    primary: '#23272b',
    selectedDiv: '#daff0d',
    hoveredDiv: '#daff0d',
    selectedIcon: '#23272b',
  },
  power4u: {
    primary: '#111111',
    selectedDiv: '#8c8c8c',
    hoveredDiv: '#8c8c8c',
    selectedIcon: '#111111',
  },
  sistelengenharia: {
    primary: '#0072ce',
    selectedDiv: '#b7c9eb',
    hoveredDiv: '#b7c9eb',
    selectedIcon: '#0072ce',
  },
  fwglocacao: {
    primary: '#ff520c',
    selectedDiv: 'rgba(255, 82, 12, 0.25)',
    hoveredDiv: 'rgba(255, 82, 12, 0.25)',
    selectedIcon: '#ff520c',
  },
  maxicharger: {
    primary: '#84bd00',
    selectedDiv: '#c8efaa',
    hoveredDiv: '#c8efaa',
    selectedIcon: '#84bd00',
  },
  dsax: {
    primary: '#111111',
    selectedDiv: '#8c8c8c',
    hoveredDiv: '#8c8c8c',
    selectedIcon: '#111111',
  },
  ispsolucoes: {
    primary: '#141414',
    selectedDiv: '#e8e8e8',
    hoveredDiv: '#e8e8e8',
    selectedIcon: '#141414',
  },
  rudniksolucoes: {
    primary: '#40e40c',
    selectedDiv: '#71f543',
    hoveredDiv: '#71f543',
    selectedIcon: '##40e40c',
  },
  plugandcharge: {
    primary: '#97b46e',
    selectedDiv: '#6c6c6c',
    hoveredDiv: '#97b46e',
    selectedIcon: '#fff',
  },
  expressaosolar: {
    primary: '#ff5d00',
    selectedDiv: '#f8b612',
    hoveredDiv: '#f8b612',
    selectedIcon: '#fff',
  },
  ledax: {
    primary: '#1f87a2',
    selectedDiv: '#a5e1e3',
    hoveredDiv: '#a5e1e3',
    selectedIcon: '#1f87a2',
  },
  brzenergia: {
    primary: '#deba36',
    selectedDiv: '#f7eed3',
    hoveredDiv: '#f7eed3',
    selectedIcon: '#deba36',
  },
  greencharger: {
    primary: '#83a05f',
    selectedDiv: '#83a05f',
    hoveredDiv: '#83a05f',
    selectedIcon: 'rgba(0, 0, 0, 0.6)',
  },
  planetacharge: {
    primary: 'rgba(67, 67, 68, .75)',
    selectedDiv: 'rgba(67, 67, 68, .75)',
    hoveredDiv: 'rgba(67, 67, 68, .75)',
    selectedIcon: '#74eb44',
  },
  isofen: {
    primary: '#0f4257',
    selectedDiv: '#0f4257',
    hoveredDiv: '#0f4257',
    selectedIcon: '#ecb644',
  },
  carpos: {
    primary: '#042a3a',
    selectedDiv: '#042a3a',
    hoveredDiv: '#042a3a',
    selectedIcon: '#e04f2a',
  },
  plugbra: {
    primary: '#345454',
    selectedDiv: '#345454',
    hoveredDiv: '#345454',
    selectedIcon: '#74c45c',
  },
  eveletroposto: {
    primary: '#3cba4d',
    selectedDiv: '#3cba4d',
    hoveredDiv: '#3cba4d',
    selectedIcon: '#06568d',
  },
  powersuntech: {
    primary: '#726c6c',
    selectedDiv: '#726c6c',
    hoveredDiv: '#726c6c',
    selectedIcon: '#fccc0c',
  },
  masterev: {
    primary: '#239e94',
    selectedDiv: '#239e94',
    hoveredDiv: '#239e94',
    selectedIcon: '#23244b',
  },
  nowcharge: {
    primary: '#b0f375',
    selectedDiv: '#b0f375',
    hoveredDiv: '#b0f375',
    selectedIcon: '#000000',
  },
  chargetec: {
    primary: '#343434',
    selectedDiv: '#343434',
    hoveredDiv: '#343434',
    selectedIcon: '#58c136',
  },
  tauste: {
    primary: '#244b7c',
    selectedDiv: '#244b7c',
    hoveredDiv: '#244b7c',
    selectedIcon: '#f38323',
  },
  pgz: {
    primary: '#4c5c64',
    selectedDiv: '#4c5c64',
    hoveredDiv: '#4c5c64',
    selectedIcon: '#ec6506',
  },
  wallbox: {
    primary: '#3e9a8f',
    selectedDiv: '#3e9a8f',
    hoveredDiv: '#3e9a8f',
    selectedIcon: '#f2f3f3',
  },
  eletricarr: {
    primary: '#444444',
    selectedDiv: '#444444',
    hoveredDiv: '#444444',
    selectedIcon: '#05bd35',
  },
  azulenergia: {
    primary: '#d9deed',
    selectedDiv: '#d9deed',
    hoveredDiv: '#d9deed',
    selectedIcon: '#2c3ca4',
  },
  planetacharger: {
    primary: '#44b769',
    selectedDiv: '#44b769',
    hoveredDiv: '#44b769',
    selectedIcon: '#0c68b1',
  },
  neoenergia: {
    primary: '#0ba247',
    selectedDiv: '#1faff1',
    hoveredDiv: '#0ba247',
    selectedIcon: '#fa9c1d',
  },
  eletrograal: {
    primary: '#4c803d',
    selectedDiv: '#4c803d',
    hoveredDiv: '#4c803d',
    selectedIcon: '#a5cd6e',
  },
  ecozenergy: {
    primary: '#05a85b',
    selectedDiv: '#05a85b',
    hoveredDiv: '#05a85b',
    selectedIcon: '#2c2c2c',
  },
  descarbonize: {
    primary: '#e548cd',
    selectedDiv: '#04c6d7',
    hoveredDiv: '#04c6d7',
    selectedIcon: '#e548cd',
  },
  chargerpro: {
    primary: '#245463',
    selectedDiv: '#245463',
    hoveredDiv: '#245463',
    selectedIcon: '#57ad64',
  },
  condominiodijon: {
    primary: '#b19b7c',
    selectedDiv: '#b19b7c',
    hoveredDiv: '#b19b7c',
    selectedIcon: '#2a1c11',
  },
  plugreen: {
    primary: '#40d41c',
    selectedDiv: '#40d41c',
    hoveredDiv: '#40d41c',
    selectedIcon: '#ffffff',
  },
  plug_charge: {
    primary: '#1c8f46',
    selectedDiv: '#1c8f46',
    hoveredDiv: '#1c8f46',
    selectedIcon: '#eeb52a',
  },
  creluz: {
    primary: '#f03434',
    selectedDiv: '#f03434',
    hoveredDiv: '#f03434',
    selectedIcon: '#ffffff',
  },
  jardimreboucas: {
    primary: '#545c34',
    selectedDiv: '#545c34',
    hoveredDiv: '#545c34',
    selectedIcon: '#e48c6d',
  },
  echargerhub: {
    primary: '#043474',
    selectedDiv: '#043474',
    hoveredDiv: '#043474',
    selectedIcon: '#44e9bc',
  },
  jng: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  myplugbrasil: {
    primary: '#5ca40c',
    selectedDiv: '#5ca40c',
    hoveredDiv: '#5ca40c',
    selectedIcon: '#2e5634',
  },
  gtconect: {
    primary: '#818181',
    selectedDiv: '#818181',
    hoveredDiv: '#818181',
    selectedIcon: '#fc9650',
  },
  mocelin: {
    primary: '#f6a145',
    selectedDiv: '#f6a145',
    hoveredDiv: '#f6a145',
    selectedIcon: '#fb0404',
  },
  plugmove: {
    primary: '#fb7f0a',
    selectedDiv: '#fb7f0a',
    hoveredDiv: '#fb7f0a',
    selectedIcon: '#ffffff',
  },
  vapt: {
    primary: '#3c7dfc',
    selectedDiv: '#3c7dfc',
    hoveredDiv: '#3c7dfc',
    selectedIcon: '#040404',
  },
  arenaenergia: {
    primary: '#1c2c4f',
    selectedDiv: '#1c2c4f',
    hoveredDiv: '#1c2c4f',
    selectedIcon: '#dae0e8',
  },
  lindenlight: {
    primary: '#231c52',
    selectedDiv: '#231c52',
    hoveredDiv: '#231c52',
    selectedIcon: '#f18b34',
  },
  nbksolucoes: {
    primary: '#29c548',
    selectedDiv: '#29c548',
    hoveredDiv: '#29c548',
    selectedIcon: '#222020',
  },
  vaga55: {
    primary: '#429741',
    selectedDiv: '#429741',
    hoveredDiv: '#429741',
    selectedIcon: '#040404',
  },
  merisol: {
    primary: '#39b4ec',
    selectedDiv: '#39b4ec',
    hoveredDiv: '#39b4ec',
    selectedIcon: '#FFFFFF',
  },
  gatway: {
    primary: '#99c273',
    selectedDiv: '#99c273',
    hoveredDiv: '#99c273',
    selectedIcon: '#040404',
  },
  canaa: {
    primary: '#04a8e6',
    selectedDiv: '#04a8e6',
    hoveredDiv: '#04a8e6',
    selectedIcon: '#2c54a4',
  },
  threel_amazon: {
    primary: '#dc642c',
    selectedDiv: '#dc642c',
    hoveredDiv: '#dc642c',
    selectedIcon: '#142c24',
  },
  eletrix: {
    primary: '#089cdd',
    selectedDiv: '#089cdd',
    hoveredDiv: '#089cdd',
    selectedIcon: '#031224',
  },
  rjeletropostos: {
    primary: '#2b87b2',
    selectedDiv: '#2b87b2',
    hoveredDiv: '#2b87b2',
    selectedIcon: '#33ca34',
  },
  bycharge: {
    primary: '#f9a519',
    selectedDiv: '#b8b8b6',
    hoveredDiv: '#b8b8b6',
    selectedIcon: '#0c7444',
  },
  recargabrasil: {
    primary: '#4fcfef',
    selectedDiv: '#4fcfef',
    hoveredDiv: '#4fcfef',
    selectedIcon: '#0c0c0c',
  },
  mbenergia: {
    primary: '#5cb38a',
    selectedDiv: '#5cb38a',
    hoveredDiv: '#5cb38a',
    selectedIcon: '#e6f1f0',
  },
  sunvale: {
    primary: '#11342d',
    selectedDiv: '#11342d',
    hoveredDiv: '#11342d',
    selectedIcon: '#f8d010',
  },
  bionovacascavel: {
    primary: '#2d2949',
    selectedDiv: '#2d2949',
    hoveredDiv: '#2d2949',
    selectedIcon: '#facd22',
  },
  poenergy: {
    primary: '#f3bc0e',
    selectedDiv: '#f3bc0e',
    hoveredDiv: '#f3bc0e',
    selectedIcon: '#040404',
  },
  chint: {
    primary: '#045cac',
    selectedDiv: '#045cac',
    hoveredDiv: '#045cac',
    selectedIcon: '#fffefe',
  },
  trovaoeletrica: {
    primary: '#78c048',
    selectedDiv: '#78c048',
    hoveredDiv: '#78c048',
    selectedIcon: '#091c34',
  },
  rap10: {
    primary: '#0c4494',
    selectedDiv: '#0c4494',
    hoveredDiv: '#0c4494',
    selectedIcon: '#FFFFFF',
  },
  alumbra: {
    primary: '#24a45c',
    selectedDiv: '#24a45c',
    hoveredDiv: '#24a45c',
    selectedIcon: '#FFFFFF',
  },
  elesol: {
    primary: '#f9ad1e',
    selectedDiv: '#f9ad1e',
    hoveredDiv: '#f9ad1e',
    selectedIcon: '#fbf4c7',
  },
  normand: {
    primary: '#141c44',
    selectedDiv: '#141c44',
    hoveredDiv: '#141c44',
    selectedIcon: '#d7dde3',
  },
  energicsolaar: {
    primary: '#e6c96d',
    selectedDiv: '#e6c96d',
    hoveredDiv: '#e6c96d',
    selectedIcon: '#FFFFFF',
  },
  be_charge: {
    primary: '#1bc532',
    selectedDiv: '#1bc532',
    hoveredDiv: '#1bc532',
    selectedIcon: '#040404',
  },
  casadoinversorsolar: {
    primary: '#0b365c',
    selectedDiv: '#0b365c',
    hoveredDiv: '#0b365c',
    selectedIcon: '#f68d50',
  },
  andradeesalescarregamentos: {
    primary: '#e7bd30',
    selectedDiv: '#e7bd30',
    hoveredDiv: '#e7bd30',
    selectedIcon: '#231c1c',
  },
  zoncharge: {
    primary: '#0076c1',
    selectedDiv: '#0076c1',
    hoveredDiv: '#0076c1',
    selectedIcon: '#f18104',
  },
  poraquerecargas: {
    primary: '#1769b6',
    selectedDiv: '#1769b6',
    hoveredDiv: '#1769b6',
    selectedIcon: '#2ba4f4',
  },
  komeco: {
    primary: '#ed322e',
    selectedDiv: '#ed322e',
    hoveredDiv: '#ed322e',
    selectedIcon: '#f5b9b4',
  },
  netmicro: {
    primary: '#040a4c',
    selectedDiv: '#040a4c',
    hoveredDiv: '#040a4c',
    selectedIcon: '#c85858',
  },
  tcharge: {
    primary: '#2c5494',
    selectedDiv: '#2c5494',
    hoveredDiv: '#2c5494',
    selectedIcon: '#05b055',
  },
  r4gestoradeenergia: {
    primary: '#212492',
    selectedDiv: 'rgba(33, 36, 146, 0.1)',
    hoveredDiv: 'rgba(33, 36, 146, 0.1)',
    selectedIcon: '#212492',
  },
  sollusmobility: {
    primary: '#325777',
    selectedDiv: '#325777',
    hoveredDiv: '#325777',
    selectedIcon: '#fadb46',
  },
  virtudev: {
    primary: '#4c4cfb',
    selectedDiv: '#4c4cfb',
    hoveredDiv: '#4c4cfb',
    selectedIcon: '#0c0c0c',
  },
  ecocarga: {
    primary: '#0e6d45',
    selectedDiv: '#0e6d45',
    hoveredDiv: '#0e6d45',
    selectedIcon: '#d4dd3c',
  },
  synnuspower: {
    primary: '#08b5d8',
    selectedDiv: '#08b5d8',
    hoveredDiv: '#08b5d8',
    selectedIcon: '#062d6a',
  },
  temcarregador: {
    primary: '#3295a2',
    selectedDiv: '#3295a2',
    hoveredDiv: '#3295a2',
    selectedIcon: '#393338',
  },
  plugauto: {
    primary: '#6fc1cd',
    selectedDiv: '#6fc1cd',
    hoveredDiv: '#6fc1cd',
    selectedIcon: '#1c1c1c',
  },
  portoseguro: {
    primary: '#60b7ea',
    selectedDiv: '#60b7ea',
    hoveredDiv: '#60b7ea',
    selectedIcon: '#f2f9f6',
  },
  carregafacil: {
    primary: '#fb6f23',
    selectedDiv: '#fb6f23',
    hoveredDiv: '#fb6f23',
    selectedIcon: '#fbaa0a',
  },
  elevetecnologia: {
    primary: '#44bcc4',
    selectedDiv: '#44bcc4',
    hoveredDiv: '#44bcc4',
    selectedIcon: '#ffffff',
  },
  evponto: {
    primary: '#3d74c3',
    selectedDiv: '#3d74c3',
    hoveredDiv: '#3d74c3',
    selectedIcon: '#43bf93',
  },
  plugcar: {
    primary: '#fb452f',
    selectedDiv: '#fb452f',
    hoveredDiv: '#fb452f',
    selectedIcon: '#040476',
  },
  lactec: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  byze: {
    primary: '#0c1443',
    selectedDiv: '#0c1443',
    hoveredDiv: '#0c1443',
    selectedIcon: '#aaf184',
  },
  onenergy: {
    primary: '#2cd461',
    selectedDiv: '#2cd461',
    hoveredDiv: '#2cd461',
    selectedIcon: '#FFFFFF',
  },
  ipiranga: {
    primary: '#0745b9',
    selectedDiv: '#0745b9',
    hoveredDiv: '#0745b9',
    selectedIcon: '#fcd404',
  },
  epanta: {
    primary: '#462a83',
    selectedDiv: '#462a83',
    hoveredDiv: '#462a83',
    selectedIcon: '#f0e210',
  },
  amazonpark: {
    primary: '#007d53',
    selectedDiv: '#007d53',
    hoveredDiv: '#007d53',
    selectedIcon: '#d4df24',
  },
  locktecnologia: {
    primary: '#041c3c',
    selectedDiv: '#041c3c',
    hoveredDiv: '#041c3c',
    selectedIcon: '#5bab04',
  },
  coletek: {
    primary: '#263353',
    selectedDiv: '#263353',
    hoveredDiv: '#263353',
    selectedIcon: '#8a1c1c',
  },
  redeteles: {
    primary: '#2c2c8c',
    selectedDiv: '#2c2c8c',
    hoveredDiv: '#2c2c8c',
    selectedIcon: '#fc944c',
  },
  hgi: {
    primary: '#fc741c',
    selectedDiv: '#fc741c',
    hoveredDiv: '#fc741c',
    selectedIcon: '#040404',
  },
  ligenergia: {
    primary: '#dec056',
    selectedDiv: '#dec056',
    hoveredDiv: '#dec056',
    selectedIcon: '#040404',
  },
  gdc_solucoes: {
    primary: '#079a55',
    selectedDiv: '#079a55',
    hoveredDiv: '#079a55',
    selectedIcon: '#2b2a29',
  },
  alper_energia: {
    primary: '#fdaf1a',
    selectedDiv: '#fdaf1a',
    hoveredDiv: '#fdaf1a',
    selectedIcon: '#1c1c1c',
  },
  ultra_tecnologia: {
    primary: '#388e1a',
    selectedDiv: '#388e1a',
    hoveredDiv: '#388e1a',
    selectedIcon: '#c7dfb8',
  },
  chargin: {
    primary: '#0d9f5a',
    selectedDiv: '#0d9f5a',
    hoveredDiv: '#0d9f5a',
    selectedIcon: '#040404',
  },
  eletropostos_nordeste: {
    primary: '#508971',
    selectedDiv: '#508971',
    hoveredDiv: '#508971',
    selectedIcon: '#241f2d',
  },
  kapplan_energy: {
    primary: '#045484',
    selectedDiv: '#045484',
    hoveredDiv: '#045484',
    selectedIcon: '#d5dee7',
  },
  energiza: {
    primary: '#3c933c',
    selectedDiv: '#3c933c',
    hoveredDiv: '#3c933c',
    selectedIcon: '#062b46',
  },
  fullcharge: {
    primary: '#3f7cf7',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  simplaenergia: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  mobilegreen: {
    primary: '#01a453',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#01a453',
  },
  boaenergia: {
    primary: '#ffb81a',
    selectedDiv: 'rgb(255, 182, 25,0.1)',
    hoveredDiv: 'rgb(255, 182, 25,0.1)',
    selectedIcon: '#ffb81a',
  },
  energybrasil: {
    primary: '#f1901b',
    selectedDiv: 'rgba(242, 145, 27, 0.1)',
    hoveredDiv: 'rgb(242, 145, 27,0.1)',
    selectedIcon: '#f1901b',
  },
  mindikacharger: {
    primary: '#49b373',
    selectedDiv: 'rgba(100, 154, 18, 0.1)',
    hoveredDiv: 'rgba(100, 154, 18, 0.1)',
    selectedIcon: '#49b373',
  },
  inntag: {
    primary: '#e10613',
    selectedDiv: 'rgb(224, 4, 19,0.1)',
    hoveredDiv: 'rgb(224, 4, 19,0.1)',
    selectedIcon: '#e10613',
  },
  automa: {
    primary: '#ec6178',
    selectedDiv: 'rgb(237, 97, 121,0.1)',
    hoveredDiv: 'rgb(237, 97, 121,0.1)',
    selectedIcon: '#ec6178',
  },
  gcargaeletroposto: {
    primary: '#434342',
    selectedDiv: 'rgba(100, 154, 18, 0.1)',
    hoveredDiv: 'rgba(100, 154, 18, 0.1)',
    selectedIcon: '#434342',
  },
  plugchargebrasil: {
    primary: '#434342',
    selectedDiv: 'rgba(100, 154, 18, 0.1)',
    hoveredDiv: 'rgba(100, 154, 18, 0.1)',
    selectedIcon: '#434342',
  },
  ecofortte_eletropostos: {
    primary: '#1f717a',
    selectedDiv: 'rgb(31, 113, 122,0.1)',
    hoveredDiv: 'rgb(31, 113, 122,0.1)',
    selectedIcon: '#1f717a',
  },
  sonnenschein: {
    primary: '#385177',
    selectedDiv: 'rgba(56, 81, 119, 0.1)',
    hoveredDiv: 'rgba(56, 81, 119, 0.1)',
    selectedIcon: '#385177',
  },
  neosolar: {
    primary: '#0199BD',
    selectedDiv: 'rgba(1, 153, 189, 0.1)',
    hoveredDiv: 'rgba(1, 153, 189, 0.1)',
    selectedIcon: '#0199BD',
  },
  tecnomotor: {
    primary: '#26ff26',
    selectedDiv: 'rgba(38, 255, 38, 0.1)',
    hoveredDiv: 'rgba(38, 255, 38, 0.1)',
    selectedIcon: '#26ff26',
  },
  e_charge_electrical: {
    primary: '#000000',
    selectedDiv: 'rgba(0, 0, 0, 0.1)',
    hoveredDiv: 'rgba(0, 0, 0, 0.1)',
    selectedIcon: '#000000',
  },
  atom_tech: {
    primary: '#f1863f',
    selectedDiv: 'rgba(241, 134, 63, 0.1)',
    hoveredDiv: 'rgba(241, 134, 63, 0.1)',
    selectedIcon: '#f1863f',
  },
  asc: {
    primary: '#000000',
    selectedDiv: 'rgba(0, 0, 0, 0.1)',
    hoveredDiv: 'rgba(0, 0, 0, 0.1)',
    selectedIcon: '#000000',
  },
  retrofit: {
    primary: '#f16775',
    selectedDiv: 'rgba(241, 103, 117, 0.1)',
    hoveredDiv: 'rgba(241, 103, 117, 0.1)',
    selectedIcon: '#f16775',
  },
  shopsolar: {
    primary: '#154776',
    selectedDiv: 'rgba(21, 71, 118, 0.1)',
    hoveredDiv: 'rgba(21, 71, 118, 0.1)',
    selectedIcon: '#154776',
  },
  chargix: {
    primary: '#000000',
    selectedDiv: 'rgba(0, 0, 0, 0.1)',
    hoveredDiv: 'rgba(0, 0, 0, 0.1)',
    selectedIcon: '#000000',
  },
  eletrotec: {
    primary: '#3C7C3A',
    selectedDiv: 'rgba(60, 124, 58, 0.1)',
    hoveredDiv: 'rgba(60, 124, 58, 0.1)',
    selectedIcon: '#3C7C3A',
  },
  eletrovias: {
    primary: '#F26B34',
    selectedDiv: 'rgba(242, 107, 52, 0.1)',
    hoveredDiv: 'rgba(242, 107, 52, 0.1)',
    selectedIcon: '#F26B34',
  },
  eletrodrive: {
    primary: '#85f000',
    selectedDiv: 'rgba(133, 240, 0, 0.1)',
    hoveredDiv: 'rgba(133, 240, 0, 0.1)',
    selectedIcon: '#85f000',
  },
  discfone: {
    primary: '#149448',
    selectedDiv: 'rgba(20, 148, 72, 0.1)',
    hoveredDiv: 'rgba(20, 148, 72, 0.1)',
    selectedIcon: '#149448',
  },
  kroma_conect: {
    primary: '#e56721',
    selectedDiv: 'rgba(229, 103, 33, 0.1)',
    hoveredDiv: 'rgba(229, 103, 33, 0.1)',
    selectedIcon: '#e56721',
  },
  g_energy: {
    primary: '#22a733',
    selectedDiv: 'rgba(34, 167, 51, 0.1)',
    hoveredDiv: 'rgba(34, 167, 51, 0.1)',
    selectedIcon: '#22a733',
  },
  volttix: {
    primary: '#138a38',
    selectedDiv: 'rgba(19, 138, 56, 0.1)',
    hoveredDiv: 'rgba(19, 138, 56, 0.1)',
    selectedIcon: '#138a38',
  },
  leroy_merlin: {
    primary: '#72bf44',
    selectedDiv: 'rgba(114, 191, 68, 0.1)',
    hoveredDiv: 'rgba(114, 191, 68, 0.1)',
    selectedIcon: '#72bf44',
  },
  europasolar: {
    primary: '#00ac65',
    selectedDiv: 'rgba(0, 172, 101, 0.1)',
    hoveredDiv: 'rgba(0, 172, 101, 0.1)',
    selectedIcon: '#00ac65',
  },
  eletroclima: {
    primary: '#ff5700',
    selectedDiv: 'rgba(255, 87, 0, 0.1)',
    hoveredDiv: 'rgba(255, 87, 0, 0.1)',
    selectedIcon: '#ff5700',
  },
  powerhub: {
    primary: '#000000',
    selectedDiv: 'rgba(0, 0, 0, 0.1)',
    hoveredDiv: 'rgba(0, 0, 0, 0.1)',
    selectedIcon: '#000000',
  },
  smartcenter: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  carregow: {
    primary: '#006836',
    selectedDiv: 'rgba(0, 104, 54, 0.1)',
    hoveredDiv: 'rgba(0, 104, 54, 0.1)',
    selectedIcon: '#006836',
  },
  mahle: {
    primary: '#1E2A63',
    selectedDiv: 'rgba(30, 42, 99, 0.1)',
    hoveredDiv: 'rgba(30, 42, 99, 0.1)',
    selectedIcon: '#1E2A63',
  },
  mobja: {
    primary: '#003399',
    selectedDiv: 'rgba(0, 51, 153, 0.1)',
    hoveredDiv: 'rgba(0, 51, 153, 0.1)',
    selectedIcon: '#003399',
  },
  hertzgoltda: {
    primary: '#0E8C98',
    selectedDiv: 'rgba(14, 140, 152, 0.1)',
    hoveredDiv: 'rgba(14, 140, 152, 0.1)',
    selectedIcon: '#0E8C98',
  },
  oasys: {
    primary: '#6747dd',
    selectedDiv: 'rgba(103, 71, 221, 0.1)',
    hoveredDiv: 'rgba(103, 71, 221, 0.1)',
    selectedIcon: '#6747dd',
  },
  condupay: {
    primary: '#0d1323',
    selectedDiv: 'rgba(10, 129, 116, 0.1)',
    hoveredDiv: 'rgba(10, 129, 116, 0.1)',
    selectedIcon: '#0d1323',
  },
  bn9: {
    primary: '#fdb812',
    selectedDiv: 'rgba(253, 184, 18, 0.1)',
    hoveredDiv: 'rgba(253, 184, 18, 0.1)',
    selectedIcon: '#fdb812',
  },
  plugandcar: {
    primary: '#4690cd0',
    selectedDiv: 'rgba(70, 144, 205, 0.1)',
    hoveredDiv: 'rgba(70, 144, 205, 0.1)',
    selectedIcon: '#4690cd',
  },
  valesol: {
    primary: '#015989',
    selectedDiv: 'rgba(50, 50, 250, 0.1)',
    hoveredDiv: 'rgba(50, 50, 250, 0.1)',
    selectedIcon: '#0341b6',
  },
  plugy: {
    primary: '#ff6301',
    selectedDiv: 'rgba(255, 99, 1, 0.1)',
    hoveredDiv: 'rgba(255, 99, 1, 0.1)',
    selectedIcon: '#cc4f01',
  },
  sollux: {
    primary: '#000000',
    selectedDiv: 'rgba(0, 0, 0, 0.1)',
    hoveredDiv: 'rgba(0, 0, 0, 0.1)',
    selectedIcon: '#000000',
  },
  amazonia_recharge: {
    primary: '#244927',
    selectedDiv: 'rgba(36, 73, 39, 0.1)',
    hoveredDiv: 'rgba(36, 73, 39, 0.1)',
    selectedIcon: '#244927',
  },
  evoluz: {
    primary: '#2D72B5',
    selectedDiv: 'rgba(45, 114, 181, 0.1)',
    hoveredDiv: 'rgba(45, 114, 181, 0.1)',
    selectedIcon: '#2D72B5',
  },
  edenred: {
    primary: '#f72717',
    selectedDiv: 'rgba(247, 39, 23, 0.1)',
    hoveredDiv: 'rgba(247, 39, 23, 0.1)',
    selectedIcon: '#f72717',
  },
  voltstation: {
    primary: '#e1a800',
    selectedDiv: 'rgba(225, 168, 0, 0.1)',
    hoveredDiv: 'rgba(225, 168, 0, 0.1)',
    selectedIcon: '#e1a800',
  },
  voltchz: {
    primary: '#06ac5d',
    selectedDiv: 'rgba(6, 172, 93, 0.1)',
    hoveredDiv: 'rgba(6, 172, 93, 0.1)',
    selectedIcon: '#06ac5d',
  },
  ezplugeletropostos: {
    primary: '#7ac943',
    selectedDiv: 'rgba(122, 201, 67, 0.1)',
    hoveredDiv: 'rgba(122, 201, 67, 0.1)',
    selectedIcon: '#7ac943',
  },
  chico_eletropostos: {
    primary: '#0078bf',
    selectedDiv: 'rgba(0, 120, 191, 0.1)',
    hoveredDiv: 'rgba(0, 120, 191, 0.1)',
    selectedIcon: '#0078bf',
  },
  centry_energy: {
    primary: '#3c7dfc',
    selectedDiv: 'rgba(60, 125, 252, 0.1)',
    hoveredDiv: 'rgba(60, 125, 252, 0.1)',
    selectedIcon: '#3c7dfc',
  },
  smileon: {
    primary: '#1138fc',
    selectedDiv: 'rgba(17, 56, 252, 0.1)',
    hoveredDiv: 'rgba(17, 56, 252, 0.1)',
    selectedIcon: '#1138fc',
  },
  g3infinitypower: {
    primary: '#A03232',
    selectedDiv: 'rgba(160, 50, 50, 0.1)',
    hoveredDiv: 'rgba(160, 50, 50, 0.1)',
    selectedIcon: '#A03232',
  },
  powergreen: {
    primary: '#94fc39',
    selectedDiv: 'rgba(148, 252, 57, 0.1)',
    hoveredDiv: 'rgba(148, 252, 57, 0.1)',
    selectedIcon: '#94fc39',
  },
  limatechenergia: {
    primary: '#90ff40',
    selectedDiv: 'rgba(144, 255, 64, 0.1)',
    hoveredDiv: 'rgba(144, 255, 64, 0.1)',
    selectedIcon: '#90ff40',
  },
  humenergia: {
    primary: '#5a62cc',
    selectedDiv: 'rgba(90, 98, 204, 0.1)',
    hoveredDiv: 'rgba(90, 98, 204, 0.1)',
    selectedIcon: '#5a62cc',
  },
  ivenergia: {
    primary: '#027a30',
    selectedDiv: 'rgba(2, 122, 48, 0.1)',
    hoveredDiv: 'rgba(2, 122, 48, 0.1)',
    selectedIcon: '#027a30',
  },
  greencar: {
    primary: '#54ad2a',
    selectedDiv: 'rgba(84, 173, 42, 0.1)',
    hoveredDiv: 'rgba(84, 173, 42, 0.1)',
    selectedIcon: '#54ad2a',
  },
  zettacharge: {
    primary: '#03B7E6',
    selectedDiv: 'rgba(3, 183, 230, 0.1)',
    hoveredDiv: 'rgba(3, 183, 230, 0.1)',
    selectedIcon: '#03B7E6',
  },
  multcharge: {
    primary: '#007625',
    selectedDiv: 'rgba(0, 118, 37, 0.1)',
    hoveredDiv: 'rgba(0, 118, 37, 0.1)',
    selectedIcon: '#007625',
  },
  tupaev: {
    primary: '#609734',
    selectedDiv: 'rgba(96, 151, 52, 0.1)',
    hoveredDiv: 'rgba(96, 151, 52, 0.1)',
    selectedIcon: '#609734',
  },
  fasthub: {
    primary: '#f38a54',
    selectedDiv: 'rgba(243, 138, 84, 0.1)',
    hoveredDiv: 'rgba(243, 138, 84, 0.1)',
    selectedIcon: '#f38a54',
  },
  movix: {
    primary: '#00bf63',
    selectedDiv: 'rgba(0, 191, 99, 0.1)',
    hoveredDiv: 'rgba(0, 191, 99, 0.1)',
    selectedIcon: '#00bf63',
  },
  rapidin: {
    primary: '#002e62',
    selectedDiv: 'rgba(0, 46, 98, 0.1)',
    hoveredDiv: 'rgba(0, 46, 98, 0.1)',
    selectedIcon: '#01ba77',
  },
  energizacar: {
    primary: '#4fb129',
    selectedDiv: 'rgba(79, 177, 41, 0.1)',
    hoveredDiv: 'rgba(79, 177, 41, 0.1)',
    selectedIcon: '#4fb129',
  },
  evgreen: {
    primary: '#060d3e',
    selectedDiv: 'rgba(6, 13, 62, 0.1)',
    hoveredDiv: 'rgba(6, 13, 62, 0.1)',
    selectedIcon: '#060d3e',
  },
  fulvio: {
    primary: '#299f6a',
    selectedDiv: 'rgba(41, 159, 106, 0.1)',
    hoveredDiv: 'rgba(41, 159, 106, 0.1)',
    selectedIcon: '#299f6a',
  },
  ezenner: {
    primary: '#f4a712',
    selectedDiv: 'rgba(244, 167, 18, 0.1)',
    hoveredDiv: 'rgba(244, 167, 18, 0.1)',
    selectedIcon: '#f4a712',
  },
  sun7: {
    primary: '#12f802',
    selectedDiv: 'rgba(18, 248, 2, 0.1)',
    hoveredDiv: 'rgba(18, 248, 2, 0.1)',
    selectedIcon: '#12f802',
  },
  energyetecnologia: {
    primary: '#07a32e',
    selectedDiv: 'rgba(7, 163, 46, 0.1)',
    hoveredDiv: 'rgba(7, 163, 46, 0.1)',
    selectedIcon: '#07a32e',
  },
  energylivre: {
    primary: '#fe3300',
    selectedDiv: 'rgba(254, 51, 0, 0.1)',
    hoveredDiv: 'rgba(254, 51, 0, 0.1)',
    selectedIcon: '#fe3300',
  },
  selectev: {
    primary: '#92c832',
    selectedDiv: 'rgba(146, 200, 50, 0.1)',
    hoveredDiv: 'rgba(146, 200, 50, 0.1)',
    selectedIcon: '#92c832',
  },
  plugev: {
    primary: '#0159fe',
    selectedDiv: 'rgba(1, 89, 254, 0.1)',
    hoveredDiv: 'rgba(1, 89, 254, 0.1)',
    selectedIcon: '#0159fe',
  },
  ca_re_go: {
    primary: '#ee9f26',
    selectedDiv: 'rgba(238, 159, 38, 0.1)',
    hoveredDiv: 'rgba(238, 159, 38, 0.1)',
    selectedIcon: '#ee9f26',
  },
  central_energy: {
    primary: '#6bad40',
    selectedDiv: 'rgba(107, 173, 64, 0.1)',
    hoveredDiv: 'rgba(107, 173, 64, 0.1)',
    selectedIcon: '#6bad40',
  },
  get_charge: {
    primary: '#f96400',
    selectedDiv: 'rgba(249, 100, 0, 0.1)',
    hoveredDiv: 'rgba(249, 100, 0, 0.1)',
    selectedIcon: '#f96400',
  },
  google: {
    primary: '#fbbc05',
    selectedDiv: 'rgba(251, 188, 5, 0.1)',
    hoveredDiv: 'rgba(251, 188, 5, 0.1)',
    selectedIcon: '#fbbc05',
  },
  openchargemap: {
    primary: '#8cc63f',
    selectedDiv: 'rgba(140, 198, 63, 0.1)',
    hoveredDiv: 'rgba(140, 198, 63, 0.1)',
    selectedIcon: '#8cc63f',
  },
  projett_charge: {
    primary: '#006294',
    selectedDiv: 'rgba(0, 98, 148, 0.1)',
    hoveredDiv: 'rgba(0, 98, 148, 0.1)',
    selectedIcon: '#006294',
  },
  voon: {
    primary: '#007c91',
    selectedDiv: 'rgba(0, 124, 145, 0.1)',
    hoveredDiv: 'rgba(0, 124, 145, 0.1)',
    selectedIcon: '#007c91',
  },
  urbfast: {
    primary: '#B4C834',
    selectedDiv: 'rgba(180, 200, 52, 0.1)',
    hoveredDiv: 'rgba(180, 200, 52, 0.1)',
    selectedIcon: '#B4C834',
  },
};
